import TextAnswer from '@/components/shared/answer-types/text/text.vue';
import { DEFAULTS } from '../../constants/club-registration-constants.js';

export default {
    name: 'BankDetailsSection',

    components: {
        'text-answer': TextAnswer
    },

    props: {
        club: {
            type: Object,
            required: true
        },
        validation: {
            type: Object,
            required: true
        },
        readOnly: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            defaults: DEFAULTS
        };
    },

    computed: {
        localClub: {
            get() { return this.club; },
            set(value) { this.$emit('update:club', value); }
        },
        localValidation: {
            get() { return this.validation; },
            set(value) { this.$emit('update:validation', value); }
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/user/dashboard/pages/clubs/register-club/sections/bank-details-section/bank-details-section.js